module.exports = __webpack_public_path__ + "static/media/Tablet.7da8ff5d.png";